<template>
    <div class="reports-general">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Relatório Sintético</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <br>

        <div class="box-filter">
            <mu-paper :z-depth="1">
                <mu-select label="Mês *" v-model="filter.month" full-width placeholder="Selecione um Mês" class="ml-1">
                    <mu-option v-for="(item, key) in options.months" :key="key" :label="item.label" :value="item.value"></mu-option>
                </mu-select>
                <mu-select label="Ano *" v-model="filter.year" full-width placeholder="Selecione um Ano" class="ml-1">
                    <mu-option v-for="(item, key) in options.years" :key="key" :value="item" :label="`${item}`"></mu-option>
                </mu-select>
                <mu-text-field v-model="filter.name" full-width @keyup.enter="filterLoad()" label="Nome/Nome Fantasia"></mu-text-field>
                <mu-button color="primary" round @click="filterLoad()" :disabled="!filter.month || !filter.year">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Buscar
                </mu-button>
                <mu-button round @click="filterClear()">
                    <font-awesome-icon icon="times" class="icon-md icon-margin-left"/>
                    Limpar
                </mu-button>
            </mu-paper>
        </div>

        <br>

        <mu-paper :z-depth="1" v-if="report.list.length > 0">
            <!-- Listagem dos grupos -->
            <mu-data-table stripe :columns="report.columns" :data="report.list" class="mu-table-custom">
                <template slot="empty">
                    <div class="box-table-empty">
                        Não foi encontrado registros.
                    </div>
                </template>
                <template slot-scope="scope">
                    <td>{{ scope.row.nick_name }}</td>
                    <td class="is-center">{{ getSignatureType(scope.row.signature_type) }}</td>
                    <td class="is-center">{{ getCustomType(scope.row.custom_type) }}</td>
                    <td class="is-center">
                        <div v-if="scope.row.deleted_at == ''">
                            <mu-badge content="Inativo" v-if="scope.row.status != 'A'"></mu-badge>
                            <mu-badge content="Ativo" v-if="scope.row.status == 'A'" color="success"></mu-badge>
                        </div>
                        <div v-else>
                            <mu-badge content="Excluido" color="error"></mu-badge>
                        </div>
                    </td>
                    <td class="is-center">{{ scope.row.sends }}</td>
                    <td class="is-center">{{ scope.row.receiveds }}</td>
                    <td class="is-center">{{ scope.row.tts }}</td>
                </template>
            </mu-data-table>
        </mu-paper>

        <!-- Paginação -->
        <mu-flex class="paginate" justify-content="center" v-if="report.paging.total > report.paging.size">
            <mu-pagination :total="report.paging.total" :page-count="5" :page-size="report.paging.size" :current.sync="report.paging.page" @change="load()"></mu-pagination>
        </mu-flex>
    </div>
</template>

<script>
    import ReportService from '@/services/services/reports'

    export default {
        name: 'app-reports-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Relatórios',
                        route: 'app.services.reports',
                        disabled: false
                    },
                    {
                        text: 'Relatório Sintético',
                        disabled: true
                    }
                ],
                options: {
                    title: '',
                    months: [
                        { value: 1, label: 'Janeiro' },
                        { value: 2, label: 'Fevereiro' },
                        { value: 3, label: 'Março' },
                        { value: 4, label: 'Abril' },
                        { value: 5, label: 'Maio' },
                        { value: 6, label: 'Junho' },
                        { value: 7, label: 'Julho' },
                        { value: 8, label: 'Agosto' },
                        { value: 9, label: 'Setembro' },
                        { value: 10, label: 'Outubro' },
                        { value: 11, label: 'Novembro' },
                        { value: 12, label: 'Dezembro' }
                    ],
                    years: []
                },
                filter: {},
                report: {
                    paging: {
                        total: 0,
                        size: 10,
                        page: 1
                    },
                    columns: [
                        { title: 'Empresa', name: 'nick_name', sortable: true },
                        { title: 'Assinatura', name: 'signature_type', align: 'center' },
                        { title: 'Tipo Cliente', name: 'custom_type', align: 'center' },
                        { title: 'Status', name: 'status', align: 'center' },
                        { title: 'SMS Enviado', name: 'sends', align: 'center', width: '160', sortable: true },
                        { title: 'SMS Recebido', name: 'receiveds', align: 'center', width: '160', sortable: true },
                        { title: 'TTS', name: 'tts', align: 'center', width: '160', sortable: true }
                    ],
                    list: []
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Pegamos os dados da empresa gravadas no STATE
             */
            companie () {
                return this.$store.state.company || null
            },

            /**
             * Verificamos se a empresa logada é uma Revenda ou é a Ziad
             */
            isHaveClients () {
                return this.isZiad() || (this.companie && this.companie.customType === 'R')
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de grupos assim que
         * o componente é montado
         */
        created () {
            let date = new Date()
            let year = date.getFullYear()

            for (let index = 2019; index <= year; index++) {
                this.options.years.push(index)
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {},

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            filterLoad () {
                this.report.paging.page = 1
                this.load()
            },
            filterClear () {
                this.filter = {
                    name: '',
                    month: '',
                    year: ''
                }
                this.report.paging.page = 1
                this.report.paging.size = 10
                this.report.paging.total = 0
                this.report.list = []
            },
            async load () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Processando o relatório.')

                    this.options.title = ''

                    let data = {
                        page: this.report.paging.page,
                        month: this.filter.month,
                        year: this.filter.year,
                        name: this.filter.name
                    }

                    let result = await ReportService.reportSynthetic(data)

                    if (result && result.status) {
                        this.report.paging.page = result.currentPage
                        this.report.paging.total = result.rowCount
                        this.report.list = result.results
                        this.options.title = `${data.month} / ${data.year}`
                        this.$eventHub.$emit('loading', false)
                        return
                    }
                } catch (e) {
                    this.$eventHub.$emit('loading', false)
                    this.$eventHub.$emit('snackbar', 'error', 'Ocorreu um problema ao gerar o relatório..')
                }
            },

            getSignatureType (type) {
                switch (type) {
                case 'C':
                    return 'Pós Pago'
                case 'P':
                    return 'Pré Pago'
                case 'T':
                    return 'Teste'
                }
                return '-'
            },

            getCustomType (type) {
                switch (type) {
                case 'R':
                    return 'Revenda'
                case 'C':
                    return 'Cliente'
                }
                return '-'
            },

            countTotal (type) {
                return this.report.list.reduce((total, item) => {
                    if (type === 'sends') {
                        return item.sends + total
                    }
                    return item.receiveds + total
                }, 0)
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../../assets/stylus/bootstrap.styl'

    .mu-select-content
        .mu-selection-text
            display none !important

    .reports-general

        .paginate
            padding 20px

        .mu-table
            width 100%
            background none
            color darken($grey, 30%)
            tr
                height auto
                &:hover
                    background lighten($grey, 70%)
                    color #000
                th
                    background lighten($grey, 50%)
                    padding 6px 2px 2px 6px
                    font-size 12px
            td
                padding 6px 2px 2px 6px
                font-size 12px

        table, th, td
            border-collapse collapse

        .box-options
            padding-bottom 15px

            .mu-button
                margin-right 10px

    .box-filter
        text-align center
        .mu-paper
            padding 10px 20px 20px 20px
        .mu-input
            margin-bottom 0
            width 100%
            margin-right 15px
        .mu-button
            margin-left 10px

    .card-info
        text-align center
        color #666
        margin-bottom 15px
        padding 15px 0
        h1
            margin 8px 0
            color #19c462
            font-size 40px
            line-height 40px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .box-filter
            text-align left
            .mu-input
                width 256px !important

        .ml-1
            margin-left 10px
</style>
